<template>
  <v-container v-if="!loading"
    ><!--force wait for responeMap to initialize-->
    <div
      style="margin-top:50px;"
      class="text-center"
      v-if="currentPoll.status === 'waiting'"
    >
      <img width="120px" src="../assets/pollsicon.png" alt="Polls" />
    </div>
    <div v-else>
      <v-card elevation="3">
        <!-- DISPLAY POLL QUESTION -->

        <v-card-subtitle style="font-size: 103%; word-break: normal;">{{
          currentPoll.pollText
        }}</v-card-subtitle>
        <v-card-text class="text-center" v-if="errors.length">
          <div
            style="color:red;"
            v-for="(error, index) in errors"
            v-bind:key="index"
          >
            {{ error.msg }}
          </div>
        </v-card-text>
        <v-divider class="pb-m1"></v-divider>

        <div v-if="currentPoll.status === 'ready'">
          <v-card-text>
            <RadioQuestion
              :poll="currentPoll"
              :value="currentPoll.voteResponse"
              @input="currentPoll.voteResponse = $event"
            />
          </v-card-text>
          <v-card-actions class="pt-0 pb-5 justify-center">
            <v-btn
              :disabled="previousDisable"
              outlined
              small
              color="primary"
              @click="previousPoll"
              ><v-icon class="pr-1" small>mdi-chevron-left</v-icon
              >Previous</v-btn
            >
            <v-btn
              small
              width="125px"
              outlined
              color="primary"
              @click="saveVote"
              >Submit</v-btn
            ><v-btn
              :disabled="nextDisable"
              outlined
              small
              color="primary"
              @click="nextPoll"
              >Next<v-icon class="pr-1" small>mdi-chevron-right</v-icon></v-btn
            >
          </v-card-actions>
        </div>
        <!-- STATUS EDIT -->
        <div v-if="currentPoll.status === 'edit'">
          <v-card-text>
            <RadioQuestion
              :poll="currentPoll"
              v-model="currentPoll.voteResponse"
            />
          </v-card-text>
          <v-card-actions class="pt-0 pb-5 justify-center">
            <v-btn
              :disabled="!currentPoll.voteResponse.length"
              small
              outlined
              color="primary"
              @click="saveVote"
              ><v-icon class="pr-1" small>mdi-check</v-icon>Submit</v-btn
            >
            <v-btn outlined small color="primary" @click="editCancel"
              ><v-icon class="pr-1" small>mdi-close</v-icon>cancel</v-btn
            >
          </v-card-actions>
        </div>

        <!-- STATUS SUBMITTED -->
        <div v-if="currentPoll.status === 'submitted'">
          <v-card-text
            ><VoteResults
              :poll="currentPoll"
              :voteResponse="currentPoll.voteResponse"
            ></VoteResults
          ></v-card-text>
          <v-card-actions class="pt-0 pb-5 justify-center">
            <v-btn
              :disabled="previousDisable"
              outlined
              small
              color="primary"
              @click="previousPoll"
              ><v-icon class="pr-1" small>mdi-chevron-left</v-icon
              >Previous</v-btn
            >
            <v-btn
              :disabled="!currentPoll.voteResponse.length"
              outlined
              small
              color="primary"
              @click="editResponse"
              ><v-icon class="pr-1" small>mdi-pencil</v-icon>edit
              response</v-btn
            ><v-btn
              :disabled="nextDisable"
              outlined
              small
              color="primary"
              @click="nextPoll"
              >Next<v-icon class="pr-1" small>mdi-chevron-right</v-icon></v-btn
            >
          </v-card-actions>
        </div>

        <!-- STATUS CLOSED -->
        <div v-if="currentPoll.status === 'closed'">
          <v-card-text>
            <div class="pb-2">This poll is now closed</div>
            <VoteResults
              :poll="currentPoll"
              :voteResponse="currentPoll.voteResponse"
            ></VoteResults>
          </v-card-text>
        </div>
      </v-card>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
import client from "@/services/axios";
import RadioQuestion from "@/components/Questions/Radio.vue";
import VoteResults from "@/components/Results/VoteResults.vue";
import { mapState } from "vuex";
export default {
  name: "Embed",
  components: {
    RadioQuestion,
    VoteResults
  },
  data() {
    return {
      loading: false,
      errors: [],
      status: "", // waiting, ready, submitted, edit, closed
      polls: [],
      currentPoll: {},
      voteResponse: "",
      nextDisable: false,
      previousDisable: true
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      event: (state) => state.event
    })
  },
  async created() {
    this.loading = true;
    let result = await client.get("/auth/anon/profile");
    let user = result.data.user;

    if (!user) {
      user = {
        firstName: "Anonymous",
        lastName: "User",
        email: "anonymous@user.com"
      };
      console.log("USER", user);
      await client.post("/auth/anon/login/", user);
    }
    this.$store.commit("SET_USER", user);
    await this.getPolls();
    this.loading = false;
  },
  methods: {
    async getPolls() {
      const result = await client.get("/polls/event/" + "23TplPdS");

      this.polls = result.data.map((poll) => {
        poll.voteResponse = [];
        poll.status = "ready";
        return poll;
      });

      this.currentPoll = this.polls[0];
      console.log("CURRENT_POLL", this.currentPoll);
      console.log(this.polls);
    },
    nextPoll() {
      this.errors = [];
      let index = this.polls.findIndex((p) => p._id === this.currentPoll._id);
      index = index + 1;
      if (index > 0) this.previousDisable = false;

      if (index === this.polls.length - 1) {
        this.nextDisable = true;
      }
      this.currentPoll = this.polls[index];
    },
    previousPoll() {
      this.errors = [];
      let index = this.polls.findIndex((p) => p._id === this.currentPoll._id);
      index = index - 1;
      if (index < this.polls.length - 1) this.nextDisable = false;

      if (index === 0) this.previousDisable = true;
      this.currentPoll = this.polls[index];
    },
    editCancel() {
      this.currentPoll.status = "submitted";
    },
    editResponse() {
      // API edit response in database
      this.currentPoll.status = "edit";
    },
    async displayPoll(poll) {
      this.poll = poll;

      const response = await client.get("/votes/history/" + poll._id);
      let history = response.data;
      console.log("History", history);

      if (history.length > 0) {
        this.currentPoll.voteResponse = history;
        this.status = "submitted";
        return;
      }
      this.currentPoll.voteResponse = [];
      this.status = "ready";
    },
    getAnswerTitles(ids) {
      // Filter out matching answers
      const findTitles = this.currentPoll.answers.filter((answer) =>
        ids.includes(answer._id)
      );
      // map only the titles to an array
      const titles = findTitles.map((answer) => answer.title);

      return titles;
    },
    getAnswerIds(voteResponse) {
      if (Array.isArray(voteResponse)) return voteResponse;
      if (voteResponse) return [voteResponse];
      return false;
    },
    async saveVote() {
      const voteData = {
        userId: this.user._id,
        pollId: this.currentPoll._id,
        voteResponse: this.getAnswerTitles(this.currentPoll.voteResponse),
        answerIds: this.getAnswerIds(this.currentPoll.voteResponse),
        pollText: this.currentPoll.pollText,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        email: this.user.email
      };

      if (this.status === "edit") {
        await client.delete(`/votes/${this.user._id}/${this.currentPoll._id}`);
      }

      try {
        await client.post("/votes", voteData);
        this.$socket.client.emit("voteSubmitted", voteData);
        this.currentPoll.status = "submitted";

        //let index = this.polls.findIndex((p) => p._id === this.currentPoll._id);
        //console.log('SPLICE', index);
        //this.polls.splice(index, 1, this.currentPoll);

        //this.currentPoll = this.polls[index];

        //console.log('Polls after submitted', this.polls);
        console.log("Current poll", this.currentPoll);
      } catch (err) {
        console.log(this.errors);
        if (err.response.data.errors !== undefined) {
          return (this.errors = err.response.data.errors);
        }
        this.errors.push({ msg: err.response.data.error });
      }
    }
  }
};
</script>
<style>
html {
  /*overflow:auto;*/
}
</style>
